// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"67e002af","453":"72b2ed3a","455":"53867705","977":"e33170dd"}[chunkId] + ".chunk.js";
};